import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { baseUrl } from "../../../../boot";

// Get products
export const getEmployeesList = createAsyncThunk("/get-employee-list", async (data, { rejectWithValue }) => {
  const token = localStorage.getItem("authToken");

  try {
    const response = await axios.post(`${baseUrl}adminuser/api/v1/get-employee-list`, data, {
      headers: {
        "auth-token": token,
        "Content-Type": "application/json",
      },
        // headers: {
        //     // Authorization: `Bearer ${token}`, // 🔥 FIXED
        //     "Content-Type": "application/json",
        //   },
    });
    // console.log(" response", response);
    return response; // ✅ Return only the data
  } catch (error) {
    console.error("Error fetching Leads", error);

    // ✅ Handle errors properly
    return rejectWithValue(error.response?.data?.message || "Failed to fetch Leads");
  }
});
